import Hero from '../components/Hero.jsx';
import Problem from '../components/Problem.jsx';
import Solution from '../components/Solution.jsx';
import UseCases from '../components/UseCases.jsx';
import Architecture from '../components/Architecture.jsx';
import About from '../components/About.jsx';
import FinalCTA from '../components/FinalCTA.jsx';
import Footer from '../components/Footer.jsx';

export default function Home() {
  return (
    <>
      <Hero />
      <Problem />
      <Solution />
      <UseCases />
      <Architecture />
      <About />
      <FinalCTA />
      <Footer />
    </>
  );
}
